export default __webpack_public_path__ + "static/media/logo-notext.06f9e085.png";